import { makeContractCancellationsRepository } from 'modules/customer/infra/repositories';

import { RequestContractCancellationNewLinkUseCase } from './implementations/RequestContractCancellationNewLinkUseCase';

let instance: RequestContractCancellationNewLinkUseCase | null = null;

export default function makeRequestContractCancellationNewLinkUseCase() {
  if (!instance) {
    const repository = makeContractCancellationsRepository();

    instance = new RequestContractCancellationNewLinkUseCase(repository);
  }

  return instance;
}
